import type { Environment } from '@openeducation/oe-it-services';

import AskTeacherDao from './dao/ask-teacher.dao';

export abstract class AskTeacherService {
  static async getQuestionsCount(env: Environment, teacherId?: number) {
    if (!teacherId) {
      throw new Error('Missing teacherId');
    }

    return AskTeacherDao.getQuestionsCount(env, teacherId);
  }

  static async getNextQuestion(env: Environment, teacherId?: number) {
    if (!teacherId) {
      throw new Error('Missing teacherId');
    }

    return AskTeacherDao.getNextQuestion(env, teacherId);
  }

  static async answerQuestion(
    env: Environment,
    answer: string,
    teacherId?: number,
    questionId?: string
  ) {
    if (!teacherId) {
      throw new Error('Missing teacherId');
    }

    if (!questionId) {
      throw new Error('Missing questionId');
    }

    return AskTeacherDao.answerQuestion(env, answer, teacherId, questionId);
  }
}
